import { z } from "zod";
import { TaskType } from "@/types/v2";
import { DUE_DATE_UNITS, DueDateUnit } from "@/lib/taskDueDate";

// z.enum() wants a mutable [T, ...T[]] tuple type; DUE_DATE_UNITS is a
// readonly `as const` array, so cast it the same way the existing
// WorkingDays schema (ShopSettingsForm.tsx) casts its own const-object
// values before handing them to z.enum().
const DUE_DATE_UNIT_VALUES = DUE_DATE_UNITS as unknown as [
  DueDateUnit,
  ...DueDateUnit[],
];

export const taskFormSchema = z
  .object({
    title: z.string().min(1, "Title is required"),
    description: z.string().optional(),
    assigneeId: z.string().optional(),
    type: z.enum(Object.values(TaskType) as [TaskType, ...TaskType[]]),
    relatedRO: z.string().optional(),
    isPrivate: z.boolean().default(false),
    dueDateMode: z.enum(["exact", "relative"]),
    dueDateExact: z.date().optional(),
    dueDateRelativeAmount: z.coerce
      .number({ invalid_type_error: "Enter a number" })
      .int("Whole numbers only")
      .nonnegative("Must be zero or greater")
      .optional(),
    dueDateRelativeUnit: z.enum(DUE_DATE_UNIT_VALUES).optional(),
  })
  .superRefine((values, ctx) => {
    if (values.dueDateMode === "exact" && !values.dueDateExact) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["dueDateExact"],
        message: "Due date is required",
      });
    }
    if (
      values.dueDateMode === "relative" &&
      (values.dueDateRelativeAmount === undefined ||
        values.dueDateRelativeUnit === undefined)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["dueDateRelativeAmount"],
        message: "Enter an amount and unit",
      });
    }
  });

export type TaskFormValues = z.infer<typeof taskFormSchema>;
